// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.web.user.property.enums.FeedOverrideSection

export enum FeedOverrideSection {
  AMENITIES = 'amenities',
  BUILDING_DETAILS = 'buildingDetails',
  CONTACT = 'contact',
  COSTS_AND_FEES = 'costsAndFees',
  FLOOR_PLANS = 'floorPlans',
  MEDIA = 'media',
  POLICIES = 'policies',
  SPECIAL_OFFERS = 'specialOffers',
}

export const FeedOverrideSection_values = [
  FeedOverrideSection.AMENITIES,
  FeedOverrideSection.BUILDING_DETAILS,
  FeedOverrideSection.CONTACT,
  FeedOverrideSection.COSTS_AND_FEES,
  FeedOverrideSection.FLOOR_PLANS,
  FeedOverrideSection.MEDIA,
  FeedOverrideSection.POLICIES,
  FeedOverrideSection.SPECIAL_OFFERS,
] as const;
